import React from "react";
import {
  Button,
  FormControl,
  FormHelperText,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@material-ui/core";
import DateFnsUtils from "@date-io/date-fns";
import deLocale from "date-fns/locale/es";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import { Controller } from "react-hook-form";
import { styleCollective } from "../styleService";

const FormSearchExamByService = ({
  register,
  control,
  handleSubmit,
  errors,
  cleanForm,
  onSubmit,
  regional,
}) => {
  const classes = styleCollective();

  const handleUserKeyPress = (e) => {
    let invalidChars = ["-", "e", "+", "E", ".", ","];
    if (invalidChars.includes(e.key)) {
      e.preventDefault();
    }
  };

  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={2} lg={2}>
            <FormControl fullWidth>
              <MuiPickersUtilsProvider locale={deLocale} utils={DateFnsUtils}>
                <Controller
                  as={
                    <KeyboardDatePicker
                      fullWidth
                      inputVariant="outlined"
                      variant="inline"
                      name="from"
                      className={classes.inputForm}
                      format="dd/MM/yyyy"
                      dateFormat="dd/MM/yyyy"
                      label="Desde"
                      InputLabelProps={{ shrink: true }}
                      //onChange={onChangeInfoContract}
                      error={
                        !!errors.hasOwnProperty("from") &&
                        errors["from"].message
                      }
                      helperText={
                        !!errors.hasOwnProperty("from") &&
                        errors["from"].message
                      }
                      minDate={"01.01.1900"}
                      minDateMessage={"No puede ser menor a 1900"}
                      //maxDate={maxDate}
                    />
                  }
                  control={control}
                  name="from"
                  placeholder="dd/mm/yyyy"
                  size="small"
                  defaultValue={null}
                />
              </MuiPickersUtilsProvider>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={2} lg={2}>
            <FormControl fullWidth>
              <MuiPickersUtilsProvider locale={deLocale} utils={DateFnsUtils}>
                <Controller
                  as={
                    <KeyboardDatePicker
                      fullWidth
                      inputVariant="outlined"
                      variant="inline"
                      name="to"
                      className={classes.inputForm}
                      format="dd/MM/yyyy"
                      dateFormat="dd/MM/yyyy"
                      label="Hasta"
                      InputLabelProps={{ shrink: true }}
                      //onChange={onChangeInfoContract}
                      error={
                        !!errors.hasOwnProperty("to") && errors["to"].message
                      }
                      helperText={
                        !!errors.hasOwnProperty("to") && errors["to"].message
                      }
                      minDate={"01.01.1900"}
                      minDateMessage={"No puede ser menor a 1900"}
                      //maxDate={maxDate}
                    />
                  }
                  control={control}
                  name="to"
                  placeholder="dd/mm/yyyy"
                  size="small"
                  defaultValue={null}
                />
              </MuiPickersUtilsProvider>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={2} lg={2}>
            <FormControl fullWidth>
              <TextField
                InputLabelProps={{ shrink: true }}
                inputRef={register}
                type="number"
                name="document"
                defaultValue=""
                className={classes.inputForm}
                label="Número de documento"
                variant="outlined"
                fullWidth
                size="small"
                onKeyPress={handleUserKeyPress}
                error={
                  errors.hasOwnProperty("document") &&
                  errors["document"].message
                }
              />
              <FormHelperText style={{ color: "#f44336", paddingLeft: 14 }}>
                {errors.hasOwnProperty("document") &&
                  errors["document"].message}
              </FormHelperText>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={3} lg={3}>
            <FormControl
              variant="outlined"
              fullWidth
              size="small"
              error={
                !!errors.hasOwnProperty("regional") &&
                errors["regional"].message
              }
            >
              <InputLabel htmlFor="outlined-select-regional" shrink={true}>
                Regional
              </InputLabel>
              <Controller
                fullWidth
                control={control}
                name="regional"
                inputRef={register}
                defaultValue=""
                className={classes.inputForm}
                label="Regional"
                size="small"
                notched={true}
                inputProps={{
                  name: "regional",
                  id: "outlined-select-regional",
                }}
                as={
                  <Select>
                    {regional?.map((res) => (
                      <MenuItem
                        key={res?.id}
                        value={res?.id}
                        className={classes.menuItem}
                      >
                        {res.name}
                      </MenuItem>
                    ))}
                  </Select>
                }
              />
              <FormHelperText style={{ color: "#f44336", paddingLeft: 14 }}>
                {errors.hasOwnProperty("regional") &&
                  errors["regional"].message}
              </FormHelperText>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={3} lg={3}>
            <Button
              variant="outlined"
              type="submit"
              className={classes.buttonSearch}
            >
              Buscar
            </Button>
            &nbsp;&nbsp;
            <Button
              variant="outlined"
              className={classes.buttonSearch}
              onClick={cleanForm}
            >
              Limpiar
            </Button>
          </Grid>
        </Grid>
      </form>
    </div>
  );
};

export default FormSearchExamByService;
